const Colors = {
  ACCENT: {
    main: "#ACC3FF",
    secondary: "#668FF9",
  },
  NEUTRAL: {
    main: "#000",
    secondary: "#adadad",
    white: "#fff",
    grey: "#A5A4A8",
    mint: "#075095",
    lightMint: "#DBF8F3",
    green: "#25DB83",
    lightGreen: "#075095",
    darkGreen: "#304858",
    darkBlue: "#304858",
  },
  ICON: {
    main: "#075095",
    secondary: "#adadad",
  },
};

export default Colors;
